<template>
  <div id="success">
    <div class="success"></div>
    <h5>提交成功，审核中！</h5>
    <p>您已申请成为本协会
      <apply-name tag="span" />
      <br />
      需要您缴纳会费：
      <fee-amount tag="em" unit="元" /> 
    </p>
    <div class="btn-main btn-home" @click="$router.push('/')">
      返回首页
    </div>
  </div>
</template>

<script>
import ApplyName from '@/components/member/ApplyName.vue';
import FeeAmount from '@/components/member/FeeAmount.vue';
  export default {
    components: {
      ApplyName,
      FeeAmount
    },
    data() {
      return { 
      }
    },
    created() { 
    },
    methods: {
       
       
    }
  }

</script>

<style lang="less" scoped>
  

  #success {
    height: 1334/@rem-size;
    background: #fff;
  }

  .success {
    width: 100%;
    height: 437/@rem-size;
    background: url('../../assets/images/wait.png');
    background-size: 100% 100%;
  }

  h5 {
    font-size: 36/@rem-size;
    color: #333;
    margin-top: 24/@rem-size;
    font-weight: normal;
    text-align: center;
  }

  p {
    display: block;
    font-size: 28/@rem-size;
    text-align: center;
    margin-top: 24/@rem-size;
    padding: 0 24/@rem-size;
    color: #999;

    span {
      color: #333;
    }

    em {
      font-style: unset;
      color: #ff4f4f;
    }
  }

  .btn-home {
    width: 360/@rem-size;
    height: 80/@rem-size;
    text-align: center;
    line-height: 80/@rem-size;
    font-size: 36/@rem-size;
    margin: 0 auto;
    margin-top: 120/@rem-size;
    border-radius: 8/@rem-size;

    a {
      color: #fff;
    }
  }

</style>
